var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavItemPicPackage menu-item",class:[ {'on': _vm.NAV.PIC_PACKAGE.id == _vm.navIndex} ]},[_c('a',{attrs:{"href":_vm.picPackageLink,"target":"_blank"}},[_vm._v("\n    图片包\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }